import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';
var TableStyle = function TableStyle(props) {
  var _getThemeData = getThemeData(props, 'table'),
    borderColor = _getThemeData.borderColor;
  return css([".c7n-pro-table{&:not(.c7n-pro-table-bordered){.c7n-pro-table-tbody .c7n-pro-table-cell{border-right:none;}.c7n-pro-table-thead.c7n-pro-table-column-resizable{&.c7n-pro-table-thead:hover,&.c7n-pro-table-thead.c7n-pro-table-thead-hover{.c7n-pro-table-cell{border-color:", ";}}}}.c7n-pro-table-cell-inner-bordered.c7n-pro-table-cell-inner-editable{border:0.01rem solid ", ";}}"], borderColor, borderColor);
};
export default TableStyle;